<template>
  <div>
    <div v-for="(attribute, index) in value" :key="index">
      <div class="d-flex align-center">
        <v-autocomplete
          :items="attributeList"
          item-text="label"
          item-value="name"
          v-model="attribute.name"
        ></v-autocomplete>
        <v-checkbox
          class="ml-4"
          label="Required"
          v-model="attribute.required"
        ></v-checkbox>
        <v-btn
          @click="value.splice(index, 1)"
          class="ml-4"
          color="primary"
          outlined
          x-small
          >Remove</v-btn
        >
      </div>

      <div class="d-flex align-start mt-n4 mb-6">
        care setting: {{ getCareSettingList(attribute) }}
      </div>
    </div>

    <v-btn
      @click="value ? value.push({}) : (value = [{}])"
      color="primary"
      outlined
      small
      >Add</v-btn
    >
  </div>
</template>

<script>
import { has, keyBy } from "lodash";
import { mapActions, mapGetters } from "vuex";

import formElementMixin from "./formElementMixin";

export default {
  computed: {
    attributeList() {
      return this.attributeFilter({
        entityName: this.optionAttributeEntityName,
      });
    },
    attributeListKeyedByName() {
      return keyBy(this.attributeList, "name");
    },
    ...mapGetters({
      attributeFilter: "attribute/filter",
    }),
  },
  async created() {
    try {
      await Promise.all([this.attributeGetList({ reload: true })]);
    } catch (e) {
      console.log(e);
      this.$notifyError("Failed to load attribute list");
    }
  },
  data() {
    return {
      has,
    };
  },
  methods: {
    getCareSettingList(attribute) {
      if (!attribute) return "";
      const fullAttribute = this.attributeListKeyedByName[attribute.name];
      let careSettingList = [];

      ["acute", "ambulatory"].forEach(careSetting => {
        if (
          this.has(fullAttribute, careSetting) &&
          fullAttribute[careSetting]
        ) {
          careSettingList.push(careSetting);
        }
      });

      if (careSettingList.length <= 0) {
        return "n/a";
      } else {
        return careSettingList.join(", ");
      }
    },
    ...mapActions({
      attributeGetList: "attribute/list",
    }),
  },
  mixins: [formElementMixin],
  props: {
    optionAttributeEntityName: {
      required: true,
      type: String,
    },
  },
};
</script>
